export default __webpack_public_path__ + "assets/webgl/success.653e851c.png";